<template>
  <div class="photo col-md-6 col-lg-4">
    <div class="card no-shadow">
      <img 
        class="card-img-top"
        :src="photo.fileType!='pdf' ? 'https://s3-ap-southeast-2.amazonaws.com/roscon/' + photo.objectKey : require('../../assets/background.jpg')"
        alt="Property photo">
      <div class="card-body">
        <i
          @click="delPhoto()"
          class="fa fa-trash float-right text-danger fa-lg interactive-cursor">
        </i>
        <span class="text-muted">
          {{ photo.createdAt | short_date_time_format }}
        </span>
        <download-input
          :options="{ permalink: 'downloadFile', label: photo.fileName}"
          :value="{ objectKey: photo.objectKey }" />
        <h5 class="mt-3 mb-0">
          {{ description }}
        </h5>
      </div>
    </div>
  </div>
</template>

<script>
  import DownloadInput from '@/components/inputs/DownloadInput'
  import {
    DELETE_PROPERTY_PHOTO
  } from '@/vuex/types'
  export default {
    name: 'PropertyPhoto',
    props: {
      object: {
        type: Object,
        default () {
          return {}
        }
      }
    },
    components: {
      DownloadInput
    },
    computed: {
      photo () {
        return {
          Properties: [],
          ...this.object
        }
      },
      description () {
        if (this.photo.Properties && this.photo.Properties.length) {
          return this.photo.Properties[0].PropertyPhoto.description
        } else {
          return ''
        }
      }
    },
    methods: {
      async delPhoto () {
        await this.$store.dispatch(DELETE_PROPERTY_PHOTO, this.photo.uuid)
      }
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/displays/PropertyPhoto.vue